import React from "react";
import { slide as Menu } from "react-burger-menu";
import Modal from "react-responsive-modal";
import { strings } from "../loc/langs";

class Header extends React.Component {
  menuNode;

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      modelOpen: false
    };

    // Get static content from page layout (unrelated to React app).
    this.aboutAppTxt = window.document.getElementById(
      "about-app-text"
    ).innerHTML;

    // Bindings.
    this.handleStateChange = this.handleStateChange.bind(this);
    this.onCloseMenu = this.onCloseMenu.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onOpenModal = this.onOpenModal.bind(this);

    console.log(this.menuRef);
  }

  componentDidMount() {}

  handleStateChange(state) {
    console.log(arguments);
    this.setState({ menuOpen: state.isOpen });
  }

  onCloseMenu() {
    this.setState({ menuOpen: false });
  }

  onOpenModal() {
    // Close the hamburger menu.
    this.onCloseMenu();

    this.setState({ modelOpen: true });
  }
  onCloseModal() {
    this.setState({ modelOpen: false });
  }

  render() {
    console.log(this.menuNode);

    return (
      <div className="title-print-menu-container">
        <div className="title-container content-header">
          <div className="title">
            <h1 className="content-title">
              {window["_stopwatchContextInfo"].pageTitle}
            </h1>
          </div>
        </div>
        <div className="print-menu-container">
        </div>
        <Modal
          classNames={{
            modal: "modal-content",
            closeButton: "modal-close-btn"
          }}
          open={this.state.modelOpen}
          onClose={this.onCloseModal}
          center
        >
          <div
            className="modal-text"
            dangerouslySetInnerHTML={{ __html: this.aboutAppTxt }}
          ></div>
        </Modal>
      </div>
    );
  }
}

export default Header;
